(function () {
  'use strict';

  angular
    .module('itecAdministracio.entitats')
    .config(config);

  function config($stateProvider, $urlRouterProvider) {

    $urlRouterProvider.when('/entitats', '/entitats/');

    $stateProvider
      .state('entitats', {
        url: '/entitats',
        views: {
        'wrapper': {
            templateUrl: 'entitats/entitats.tpl.html',
            controller: function(AppHeaderSubmenuFactory, $stateParams, $scope, $rootScope) {
              var vm = this;

              $scope.$on('changeSides', function (event, data) {
                AppHeaderSubmenuFactory.setStateParams($stateParams, data, false);
                AppHeaderSubmenuFactory.setWrapperAttributesFromChild(vm, data);
              });
            },
            controllerAs: 'ctrl'
          }
        },
        resolve: {
          permisosLoad: function(PermisosFactory,LocaleService,$rootScope, DataFactory, ApiLayoutConstant) {
            if (angular.isUndefined($rootScope.permisos) && $rootScope.permisos == null ) {
              DataFactory.setApiParameters('security', ApiLayoutConstant.SERVER_VERSION_ADMINISTRACIO,
                'authsecurity','');
              PermisosFactory.setApiParameters(ApiLayoutConstant.SERVER_PATH_ADMINISTRACIO + 'permisos',
                'notfound');

              var promise= PermisosFactory.load().then(function (response) {
                $rootScope.permisos = response.data.permisos;
                $rootScope.usuari = response.data.usuari;
                LocaleService.setLocaleByIdioma($rootScope.usuari.idioma);
              });
              return promise;
            }
          }
        },
        breadcrumb: "DEFAULT_ENTITATS"
      });
  }
}());
